<template>
  <div>
    <v-container grid-list-lg fluid>
        <v-layout row wrap>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <v-flex lg2 md12 sm12 pr-6 pl-lg-6>
                    <mh-date-picker plabel="Từ ngày" v-model="dateRange.startDate"
                        @onChangeDate="dateRange.startDate = $event"></mh-date-picker>
                </v-flex>
                <v-flex lg2 md12 sm12 pr-6>
                    <mh-date-picker plabel="Đến ngày" v-model="dateRange.endDate"
                        @onChangeDate="dateRange.endDate = $event"></mh-date-picker>
                </v-flex>
                <v-flex lg2 md12 sm12 pr-6 pt-0>
                    <v-select :items="reportType" item-value="value" item-text="name" v-model="selectedReportType"
                        label="Loại báo cáo"></v-select>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6 pt-0>
                    <v-autocomplete label="Sale" v-model="selectedSaleId" :items="sales" item-text="first_name"
                        item-value="id" class="input-group--focused" clearable v-if="selectedReportType == 2 || selectedReportType == 3"></v-autocomplete>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6 pt-0>
                    <v-autocomplete label="Khách hàng" v-model="selectedCustomerId" :items="customers"
                        :item-text="getCustomerText" item-value="id" class="input-group--focused"
                        clearable v-if="selectedReportType == 2 || selectedReportType == 3"></v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg12 v-if="items">
                    <v-data-table hide-default-footer :headers="headers" :items="items" :options.sync="pagination" :server-items-length="items.length" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td v-if="selectedReportType == 1 || selectedReportType == 3">{{ item.report_date }}</td>
                                <td v-if="selectedSaleId">{{ item.sale_name }}</td>
                                <td v-if="selectedReportType == 2 || selectedReportType == 3">{{ item.customer_name}}</td>
                                <td v-if="selectedReportType == 4">{{ item.made_in }}</td>
                                <td class="text-end">{{ item.total_order | currency }}</td>
                                <td class="text-end">{{ item.total_qty | currency }}</td>
                                <td class="text-end">{{ item.total_amount | currency }}</td>
                            </tr>
                        </template>
                        <template v-slot:body.append>
                            <tr>
                                <td class="font-weight-bold"
                                    :colspan="(selectedReportType == 3 ? 2 : 1) + (selectedSaleId ? 1 : 0)">TỔNG</td>
                                <td class="text-end font-weight-bold">{{ dic_summary.total_order | currency }}</td>
                                <td class="text-end font-weight-bold">{{ dic_summary.total_qty | currency }}</td>
                                <td class="text-end font-weight-bold">{{ dic_summary.total_amount | currency }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import MHDatePicker from "@/components/daterange/MHDatePicker";
import _ from "lodash";
import moment from "moment"
export default {
    components: {
        "mh-date-picker": MHDatePicker
    },
    data() {
        return {
            viewName: "bao-cao-doanh-thu",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            reportType: [
                {value: 1, name: 'Theo ngày'},
                {value: 2, name: 'Theo khách'},
                {value: 3, name: 'Theo ngày & khách'},
            ],
            menuStart: false,
            menuEnd: false,
            selectedReportType: 1,
            selectedCustomerId: 0,
            selectedSaleId: 0,
            pagination: {...configs.PAGINATION, sortBy: ["report_date"]}
        };
    },
    watch: {
        filter_params() {
            this.get_receipt_report();
        },
        pagination: {
            handler: function (val, oldVal) {
                this.get_receipt_report();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            sales: state => state.users.sale.data,
            customers: state => state.users.all.data,
            items: state => state.reports.returns.data,
            loading: state => state.reports.loading,
        }),
        dic_summary() {
            return {
                'total_qty': _.sumBy(this.items, 'total_qty'),
                'total_order': _.sumBy(this.items, 'total_order'),
                'total_amount': _.sumBy(this.items, 'total_amount')
            };
        },
        headers() {
            let tmp = [];
            if (this.selectedReportType == 1 || this.selectedReportType == 3) {
                tmp.push({
                    text: "Ngày",
                    value: "report_date",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                })
            }
            if (this.selectedSaleId) {
                tmp.push({
                    text: "Sale",
                    value: "sale_name",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                })
            }
            if (this.selectedReportType == 2 || this.selectedReportType == 3) {
                tmp.push({
                    text: "Khách hàng",
                    value: "customer_name",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                })
            }
            tmp.push({
                    text: "Tổng đơn",
                    value: "total_order",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                })
            tmp.push({
                    text: "Tổng SL",
                    value: "total_qty",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                })
            tmp.push({
                text: "Tổng tiền",
                value: "total_amount",
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
            })
            return tmp;
        },
        filter_params() {
            return {
                pagination: this.pagination,
                'report_type': this.selectedReportType, 
                'uid_selected': this.selectedCustomerId ? this.selectedCustomerId : 0, 
                'sid_selected': this.selectedSaleId ? this.selectedSaleId : 0, 
                'start_date': moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT), 
                'end_date': moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
            };
        }
    },
    methods: {
        get_receipt_report() {
            this.$store.dispatch("reports/get_return_report", this.filter_params );
        },
        getCustomerText(item) {
            return `${item.phone} - ${item.first_name}`
        },
    },
    mounted() {
        this.get_receipt_report();
        this.$store.dispatch("users/getSale", {filter: [{column: 'role', value: [configs.ROLE_TYPE.Staff, configs.ROLE_TYPE.Admin], condition: "in"}]});
        this.$store.dispatch("users/getList", {filter: [{column: 'role', value: configs.ROLE_TYPE.Customer, condition: "equal"}]});
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.get_receipt_report);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}
.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>